class ProgressBarController {
    $onChanges() {
        this.value = isNaN(this.value) ? 0 : this.value;
        this.total = isNaN(this.total) ? 0 : this.total;
        const percent = this.value / this.total * 100;
        if(this.value === 0 )
        {
            this.percent = 0;
        }
        else
        {
            this.percent = Math.min(isNaN(percent) || !isFinite(percent) ? 100 : percent, 100);
        }
    }
}

export default ProgressBarController;


// WEBPACK FOOTER //
// ./components/progress-bar/progress-bar.controller.js